export const RESPONSE_SUCCESS = "000"
export const RESPONSE_ERROR = "999"
export const RESPONSE_WARNING = "555"